import React from 'react'
import { Link } from 'gatsby'

import './top_menu.scss'

export default () => {
  return (
    <div className="top-menu-container">
      <ul className="menu">
        <li>
          <Link to="/about">
            About
          </Link>
        </li>
        <li>
          <Link to="/contact">
            Contact
          </Link>
        </li>
        <li>
          <a target='_blank' href="https://careers.orrcon.com.au">
            Careers
          </a>
        </li>
      </ul>
    </div>
  )
}
